import {
  makeOrganizationPageLink,
  makeOrganizationServiceReviewsPageLink,
  makeOrganizationVitrinsPageLink,
  makeReviewLink,
} from '@sravni/ugc/lib/organizations/linkMakers';
import { OrganizationTypes } from '@sravni/ugc/lib/organizations/types';
import type IProduct from '@sravni/vitrina/lib/types/IProduct';

import type { Row } from '@tanstack/react-table';

import { RATING_TYPES } from '../../../constants/filters';
import {
  sendGoToOrganizationEvent,
  sendGoToOrganizationVitrinEvent,
  sendGoToProductReviewsEvent,
  sendGoToServiceReviewsEvent,
  sendOpenProductPopupEvent,
} from '../../../helpers/analyticsEvents';
import type { OrganizationRatingItem, ProductRatingItem } from '../../../types/rating';

type TMakeHandleRowClickParams = {
  row: Row<OrganizationRatingItem | ProductRatingItem>;
  filters: TFilters;
  products: Record<string, IProduct>;
  setProduct: (product: any) => void;
  setProductPopupVisibility: { on: () => void; off: () => void; toggle: () => void };
  canShowProductPopup: boolean;
};

export const makeHandleRowClick =
  ({ row, filters, products, setProduct, setProductPopupVisibility, canShowProductPopup }: TMakeHandleRowClickParams) =>
  () => {
    const { organizationType, service, ratingType } = filters;

    const { organizationAlias, organizationName } = row.original;

    let link = null;

    if (ratingType === RATING_TYPES.Organizations && !service) {
      // рейтинг организаций без услуги
      link = makeOrganizationPageLink(organizationAlias, organizationType);
      sendGoToOrganizationEvent({ organizationType, organizationName });
    } else if (ratingType === RATING_TYPES.Organizations && service) {
      // рейтинг организаций по услуге

      const { productCount } = (row as Row<OrganizationRatingItem>).original;
      // eslint-disable-next-line no-constant-condition
      if (productCount > 0 && false) {
        // до выяснения, как всё же формируют витрины свои урлы
        // если у организации есть витрина с продуктами
        link = makeOrganizationVitrinsPageLink(organizationAlias, organizationType, service.alias);
        sendGoToOrganizationVitrinEvent({ organizationName, service });
      }
      link = makeOrganizationServiceReviewsPageLink(organizationAlias, organizationType, service.alias);
      sendGoToServiceReviewsEvent({ organizationName, service });
    } else if (ratingType === RATING_TYPES.Products) {
      // рейтинг продуктов
      const { productId, productName } = (row as Row<ProductRatingItem>).original;

      setProduct(products?.[productId]);
      if (canShowProductPopup) {
        setProductPopupVisibility.on();
        sendOpenProductPopupEvent({ organizationName, service, productName });

        return;
      }

      if (service.key === 'mortgage' || organizationType === OrganizationTypes.EducationalOrganization) {
        // TODO: удалить костыль после доработки команды ипотеки/эдюкейшн
        return;
      }

      link = makeReviewLink({
        productId,
        organizationType,
        organizationAlias,
        serviceAlias: service.alias,
      });

      sendGoToProductReviewsEvent({
        productName,
        service,
        organizationName,
      });
    }

    if (link) document.location.href = link;
  };
